module.exports = __webpack_public_path__ + "static/img/fenzuhanhua2.bef5cdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/fenzuhanhua2.png
// module id = SlwV
// module chunks = 24